export enum ScrollContainerDirectionEnum {
  vertical = 'vertical',
  horizontal = 'horizontal',
}

export type ScrollContainerDirectionType = keyof typeof ScrollContainerDirectionEnum
